<template>
  <a-card :bordered="false" class="withdrawal-records">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="16" class="search-row">
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('date')">
              <a-range-picker
                v-model="queryParam.dateRange"
                format="DD-MM-YYYY"
                valueFormat="YYYY-MM-DD"
                style="width: 100%"
                :placeholder="[$t('platformCollection.start_time'), $t('platformCollection.end_time')]"
                @change="onDateChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('platformCollection.transaction_serial_number')">
              <a-input v-model="queryParam.referenceNumber" :placeholder="$t('enter')" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('platformCollection.bank_card_account')">
              <a-input v-model="queryParam.bankCardNo" :placeholder="$t('enter')" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('platformCollection.investor_account')">
              <a-input v-model="queryParam.mobile" :placeholder="$t('enter')" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('platformCollection.investor_type')">
              <a-select
                v-model="queryParam.type"
                style="width: 100%"
                :placeholder="$t('platformCollection.all')"
                allow-clear
              >
                <a-select-option :value="1">{{ $t('investorList.gr') }}</a-select-option>
                <a-select-option :value="2">{{ $t('investorList.qy') }}</a-select-option>
                <a-select-option :value="10">{{ $t('investorList.jg') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('platformCollection.withdrawal_status')">
              <a-select
                v-model="queryParam.status"
                style="width: 100%"
                :placeholder="$t('platformCollection.all')"
                allow-clear
              >
                <a-select-option :value="1">{{ $t('platformCollection.transaction_success') }}</a-select-option>
                <a-select-option :value="10">{{ $t('platformCollection.transaction_failed') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <div class="search-actions">
          <a-button @click="handleReset">{{ $t('platformCollection.reset') }}</a-button>
          <a-button type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
        </div>
      </a-form>
    </div>

    <div class="toolbar">
      <!-- <a-button type="primary" icon="download" @click="handleExport">{{ $t('exportFile') }}</a-button> -->
    </div>

    <a-table
      bordered
      :rowKey="(record, index) => `${record.id}-${index}`"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :loading="loading"
      :scroll="{ x: 2400 }"
      @change="handleTableChange"
    >
      <span slot="type" slot-scope="text">
        {{ typeFilter(text) }}
      </span>
      <span slot="mobile" slot-scope="text">
        {{ text | maskPhone }}
      </span>
      <span slot="status" slot-scope="text">
        {{ statusFilter(text) }}
      </span>
      <span slot="amount" slot-scope="text">
        {{ text | FenToDong }}
      </span>
      <span slot="handlingFee" slot-scope="text">
        {{ text | FenToDong }}
      </span>
      <span slot="amountReceived" slot-scope="text">
        {{ text | FenToDong }}
      </span>
    </a-table>
  </a-card>
</template>

<script>
import { getWithdrawalList } from '@/webpublicapi/vietnamBackstage'
import moment from 'moment'

export default {
  name: 'WithdrawalRecords',
  data() {
    return {
      queryParam: {
        dateRange: [],
        startDate: '',
        endDate: '',
        referenceNumber: '',
        bankCardNo: '',
        mobile: '',
        type: undefined,
        status: undefined,
      },
      columns: [
        { title: this.$t('platformCollection.withdrawal_time'), dataIndex: 'createdTime', align: 'center' },
        { title: this.$t('platformCollection.investor_name'), dataIndex: 'name', align: 'center' },
        {
          title: this.$t('platformCollection.investor_account'),
          dataIndex: 'mobile',
          align: 'center',
          scopedSlots: { customRender: 'mobile' },
        },
        {
          title: this.$t('platformCollection.investor_type'),
          dataIndex: 'type',
          align: 'center',
          scopedSlots: { customRender: 'type' },
        },
        { title: this.$t('platformCollection.transaction_serial_number'), dataIndex: 'id', align: 'center' },
        {
          title: this.$t('platformCollection.withdrawal_status'),
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: this.$t('platformCollection.application_withdrawal_amount'),
          dataIndex: 'amount',
          align: 'center',
          scopedSlots: { customRender: 'amount' },
        },
        {
          title: this.$t('platformCollection.handling_fee'),
          dataIndex: 'handlingFee',
          align: 'center',
          scopedSlots: { customRender: 'handlingFee' },
        },
        {
          title: this.$t('platformCollection.actual_amount_received'),
          dataIndex: 'amountReceived',
          align: 'center',
          scopedSlots: { customRender: 'amountReceived' },
        },
        { title: this.$t('platformCollection.withdrawal_bank_card'), dataIndex: 'bankCardNo', align: 'center' },
      ],
      dataSource: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
      },
    }
  },
  created() {
    const todayStart = moment().startOf('day')
    const todayEnd = moment().endOf('day')
    this.queryParam.dateRange = [todayStart, todayEnd]
    this.queryParam.startDate = todayStart.format('YYYY-MM-DD')
    this.queryParam.endDate = todayEnd.format('YYYY-MM-DD')
    this.loadData()
  },
  methods: {
    // Phone number masking
    maskPhone(phone) {
      if (!phone) return ''
      const phoneStr = String(phone)
      if (phoneStr.length <= 7) return phoneStr
      return phoneStr.substring(0, 3) + '****' + phoneStr.substring(phoneStr.length - 4)
    },
    typeFilter(type) {
      const typeMap = {
        1: this.$t('investorList.gr'),
        2: this.$t('investorList.qy'),
        10: this.$t('investorList.jg'),
      }
      return typeMap[type] || this.$t('platformCollection.unknown')
    },
    statusFilter(status) {
      const statusMap = {
        1: this.$t('platformCollection.transaction_success'),
        10: this.$t('platformCollection.transaction_failed'),
      }
      return statusMap[status] || this.$t('platformCollection.unknown')
    },
    onDateChange(dates, dateStrings) {
      if (!dates || dates.length === 0) {
        this.queryParam.startDate = ''
        this.queryParam.endDate = ''
        return
      }
      this.queryParam.startDate = this.queryParam.dateRange[0]
      this.queryParam.endDate = this.queryParam.dateRange[1]
    },
    handleReset() {
      const todayStart = moment().startOf('day')
      const todayEnd = moment().endOf('day')
      this.queryParam = {
        dateRange: [todayStart, todayEnd],
        startDate: todayStart.format('YYYY-MM-DD'),
        endDate: todayEnd.format('YYYY-MM-DD'),
        referenceNumber: '',
        bankCardNo: '',
        mobile: '',
        type: undefined,
        status: undefined,
      }
      this.pagination.current = 1
      this.loadData()
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    buildParams() {
      const rawParams = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        startDate: this.queryParam.startDate ? this.queryParam.startDate + ' 00:00:00' : '',
        endDate: this.queryParam.endDate ? this.queryParam.endDate + ' 23:59:59' : '',
        referenceNumber: this.queryParam.referenceNumber,
        bankCardNo: this.queryParam.bankCardNo,
        mobile: this.queryParam.mobile,
        type: this.queryParam.type,
        status: this.queryParam.status,
      }

      return Object.keys(rawParams).reduce((acc, key) => {
        const value = rawParams[key]
        if (value !== '' && value !== undefined && value !== null) {
          acc[key] = value
        }
        return acc
      }, {})
    },
    loadData() {
      this.loading = true
      getWithdrawalList(this.buildParams())
        .then((res) => {
          if (res.success || res.respCode === 1000 || res.code === 200) {
            const data = res.respData || res.result || {}
            if (data.records.length > 0) {
              data.records.forEach((item) => {
                if (item.createdTime) {
                  item.createdTime = this.transformTime(item.createdTime, 2)
                }
              })
            }
            this.dataSource = data.records || []
            this.pagination.total = data.total || 0
          } else {
            this.$message.warning(res.respMsg || res.message || this.$t('platformCollection.query_failed'))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleExport() {
      if (!this.dataSource.length) {
        this.$message.warning(this.$t('platformCollection.no_export_data'))
        return
      }

      const headers = [
        this.$t('platformCollection.withdrawal_time'),
        this.$t('platformCollection.investor_name'),
        this.$t('platformCollection.investor_account'),
        this.$t('platformCollection.investor_type'),
        this.$t('platformCollection.transaction_serial_number'),
        this.$t('platformCollection.withdrawal_status'),
        this.$t('platformCollection.application_withdrawal_amount'),
        this.$t('platformCollection.handling_fee'),
        this.$t('platformCollection.actual_amount_received'),
        this.$t('platformCollection.withdrawal_bank_card'),
      ]
      const rows = this.dataSource.map((item) => [
        item.createdTime,
        item.name,
        this.maskPhone(item.mobile),
        this.typeFilter(item.type),
        item.id,
        this.statusFilter(item.status),
        this.$options.filters.FenToDong ? this.$options.filters.FenToDong(item.amount) : item.amount,
        this.$options.filters.FenToDong ? this.$options.filters.FenToDong(item.handlingFee) : item.handlingFee,
        this.$options.filters.FenToDong ? this.$options.filters.FenToDong(item.amountReceived) : item.amountReceived,
        item.bankCardNo,
      ])

      const csvContent = [headers, ...rows]
        .map((line) => line.map((cell) => `"${String(cell === undefined ? '' : cell).replace(/"/g, '""')}"`).join(','))
        .join('\n')

      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `${this.$t('platformCollection.withdrawal_record')}_${moment().format('YYYYMMDDHHmmss')}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.withdrawal-records {
  .table-page-search-wrapper {
    margin-bottom: 12px;
  }

  .search-actions {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin: 8px 0 16px;
  }

  .toolbar {
    margin-bottom: 16px;
  }
}
</style>
